import { of, EMPTY } from "rxjs";
import { mergeMap, delay } from "rxjs/operators";
import { ofType } from "redux-observable";
import * as actions from "../../actions";
import { types as userTypes } from "../../actions/user";

export const mockCreate = (actionStream) =>
  actionStream.pipe(
    ofType(userTypes.CREATE_USER),
    mergeMap(({ payload }) =>
      of(
        actions.user.create.succeed({
          userId: 1234,
          userName: "John Snow",
          tenantId: "123-abc",
          ...payload,
        })
      ).pipe(delay(1500))
    )
  );

export const logout = (actionStream) =>
  actionStream.pipe(
    ofType(userTypes.LOGOUT),
    mergeMap(() => {
      sessionStorage.removeItem("jwt");

      return EMPTY;
    })
  );

export default [mockCreate, logout];
